module.exports = __webpack_public_path__ + "static/media/CaptureTEMP1.1cdfb62d.PNG";